import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const BosTagsService = {
    list: async () => axios.get(API_URL + "/bos-tags/list").then(({ data }) => data).catch((err) => { throw err }),

    getById: async (id) => axios.get(API_URL + `/bos-tags/${id}`).then(({ data }) => data).catch((err) => { throw err }),

    save: async (payload) => axios.post(API_URL + "/bos-tags", payload).then(({ data }) => data.data).catch((err) => { throw err }),

    update: async (id, payload) => axios.put(API_URL + `/bos-tags/${id}`, payload).then(({ data }) => data.data).catch((err) => { throw err }),

    destroy: async (id) => axios.delete(API_URL + `/bos-tags/${id}`).then(({ data }) => data.data).catch((err) => { throw err }),
}

export default BosTagsService;